module.exports = __webpack_public_path__ + "img/6d62a2b.svg";